import React from "react";

export const retrieveImprint = (): React.ReactElement => (
    <div>
        <h1>IMPRESSUM</h1>

        <p>
            Informationspflicht laut § 5 TMG.
        </p>

        <p>
            Danilo Walenta<br /> <br /> 
            Hochschuhlstraße 1,<br />
            64289 Darmstadt,<br />
            Deutschland
        </p>

        <p>
            Tel.: 06151/1624221<br />
            E-Mail: <a href="mailto:contact@danilowalenta.com">contact@danilowalenta.com</a>
        </p>

        <p>
            Quelle: Erstellt mit dem Impressum Generator von AdSimple in Kooperation mit 123familie.de
        </p>

        <h1>EU-STREITSCHLICHTUNG</h1>
        <p>
            Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten
            (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform
            (OS-Plattform) informieren.
        </p>
        <p>
            Verbraucher haben die Möglichkeit, Beschwerden an die Online-Streitbeilegungsplattform
            der Europäischen Kommission unter{" "}
            <a href="http://ec.europa.eu/odr?tid=321173233" target="_blank" rel="noreferrer">
                http://ec.europa.eu/odr?tid=321173233
            </a>{" "}
            zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.
        </p>
        <p>
            Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind,
            an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h1>HAFTUNG FÜR INHALTE DIESER WEBSITE</h1>
        <p>
            Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte
            und aktuelle Informationen bereitzustellen. Laut Telemediengesetz (TMG) §7 (1) sind
            wir als Diensteanbieter für eigene Informationen, die wir zur Nutzung bereitstellen,
            nach den allgemeinen Gesetzen verantwortlich. Leider können wir keine Haftung für die
            Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für jene die seitens
            Dritter bereitgestellt wurden. Als Diensteanbieter im Sinne der §§ 8 bis 10 sind wir
            nicht verpflichtet, die von ihnen übermittelten oder gespeicherten Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
            Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung
            von Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen
            Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit nach den §§ 8 bis 10 unberührt.
        </p>
        <p>
            Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns
            umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können.
            Sie finden die Kontaktdaten im Impressum.
        </p>

        <h1>HAFTUNG FÜR LINKS AUF DIESER WEBSITE</h1>
        <p>
            Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind.
            Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten
            hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort
            entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
        </p>
        <p>
            Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu kontaktieren.
            Sie finden die Kontaktdaten im Impressum.
        </p>

        <h1>URHEBERRECHTSHINWEIS</h1>
        <p>
            Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht der
            Bundesrepublik Deutschland. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten,
            vervielfältigen oder verwerten wie zum Beispiel auf anderen Websites erneut veröffentlichen.
            Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.
        </p>
        <p>
            Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.
        </p>

        <h1>BILDERNACHWEIS</h1>
        <p>
            Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich geschützt.
        </p>
        <p>
            Die Bilderrechte liegen bei den folgenden Fotografen und Unternehmen:<br />
            Danilo Walenta<br />
            Ionic Icons<br />
            Ant Design Icons
        </p>

        <h1>DATENSCHUTZERKLÄRUNG</h1>
        <h1>DATENSCHUTZ</h1>
        <p>
            Wir haben diese Datenschutzerklärung (Fassung 01.05.2020-321173233) verfasst, um Ihnen gemäß
            der Vorgaben der Datenschutz-Grundverordnung (EU) 2016/679 zu erklären, welche Informationen
            wir sammeln, wie wir Daten verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher
            dieser Webseite haben.
        </p>
        <p>
            Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir haben
            uns bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu beschreiben.
        </p>

        <h1>AUTOMATISCHE DATENSPEICHERUNG</h1>
        <p>
            Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und gespeichert,
            so auch auf dieser Webseite.
        </p>
        <p>
            Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem diese
            Webseite gespeichert ist) automatisch Daten wie
        </p>
        <ul>
            <li>die Adresse (URL) der aufgerufenen Webseite</li>
            <li>Browser und Browserversion</li>
            <li>das verwendete Betriebssystem</li>
            <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
            <li>den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird</li>
            <li>Datum und Uhrzeit</li>
        </ul>
        <p>
            in Dateien (Webserver-Logfiles).
        </p>
        <p>
            In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht.
            Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen
            von rechtswidrigem Verhalten eingesehen werden.
        </p>

        <h1>RECHTE LAUT DATENSCHUTZGRUNDVERORDNUNG</h1>
        <p>
            Ihnen stehen laut den Bestimmungen der DSGVO grundsätzlich die folgende Rechte zu:
        </p>
        <ul>
            <li>Recht auf Berichtigung (Artikel 16 DSGVO)</li>
            <li>Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
            <li>Recht auf Benachrichtigung (Artikel 19 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
            <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
            <li>
                Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung —
                einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)
            </li>
        </ul>
        <p>
            Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder
            Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich
            an die Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI) wenden.
        </p>

        <h1>AUSWERTUNG DES BESUCHERVERHALTENS</h1>
        <p>
            In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und wie wir Daten Ihres
            Besuchs dieser Website auswerten. Die Auswertung der gesammelten Daten erfolgt in der Regel anonym
            und wir können von Ihrem Verhalten auf dieser Website nicht auf Ihre Person schließen.
        </p>
        <p>
            Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu widersprechen erfahren Sie in der
            folgenden Datenschutzerklärung.
        </p>

        <h1>TLS-VERSCHLÜSSELUNG MIT HTTPS</h1>
        <p>
            Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch Technikgestaltung
            Artikel 25 Absatz 1 DSGVO). Durch den Einsatz von TLS (Transport Layer Security), einem
            Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können wir den Schutz vertraulicher
            Daten sicherstellen. Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am kleinen
            Schloßsymbol links oben im Browser und der Verwendung des Schemas https (anstatt http) als Teil
            unserer Internetadresse.
        </p>

        <p>
            Quelle: Erstellt mit dem Datenschutz Generator von AdSimple in Kooperation mit hashtagmann.de
        </p>
    </div>
);

export default retrieveImprint;